 
<div class="modal-content">
    <div class="text-right" style="cursor: pointer;" (click)="closeModal()">
        <mat-icon>close</mat-icon>
    </div>

    <div class="content">
        <div *ngIf="uploadedFile || selectedFiles.length > 0" class="uploaded-files">
            <h2>Uploaded File:</h2>
            <div class="row">
                <div *ngIf="uploadedFile" class="col-md-2">
                    <button class="delete-btn" (click)="deleteFile(uploadedFile)">
                        <mat-icon>close</mat-icon>
                    </button>
                    <div class="file-item">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span class="uploadFileName">{{ uploadedFileName }}</span>
                    </div>
                    
                </div>
                <div *ngFor="let file of selectedFiles" class="col-md-2">
                    <div class="file-item">
                        <button class="delete-btn" (click)="deleteFile(file)">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-icon>insert_drive_file</mat-icon>
                        <span class="uploadFileName">{{ file.name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <!-- <div class="text-center belowText">
            <div>
                <span class="names">Upload More Files</span>
                <button class="btn btn-light hover-clear clear btnIcons topbtn" (click)="uploadfile()">
                    <mat-icon class="icon">file_upload</mat-icon>
                </button>
            </div>
            <br />
            <div>
                
                <button class="btn btn-light hover-button mail" >
                    Submit
                </button>
            </div>
        </div> -->
    </div>
    <div class="button-container">
        <button class="btn btn-light hover-button mail" (click)="submitClick()">
            Submit
        </button>
    </div>
    
    <input
    type="file"
    hidden
    #fileInput
    (change)="onFileSelected($event)"
    accept=".xlsx, .xls , .xlsm, .csv"
  
  />

</div>